import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '../../../customControlRegistry';
import { HolterAnalysisReportRead } from './HolterAnalysisReportRead';

CustomControlRegistry.instance.register({
    ReadElement: HolterAnalysisReportRead,
    code: CustomControlCode.HolterAnalysisReport,
    initialData: {
        assets: [],
    },
    version: 1,
});
